<div class="min-h-screen bg-gray-900">
  <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
    <!-- Language Selector -->
    <div class="bg-gray-800/50 rounded-lg border border-gray-700/50 backdrop-blur-sm p-4 mb-6">
      <div class="flex items-center space-x-4">
        <span class="text-sm font-medium text-gray-300">Taal:</span>
        <div class="flex space-x-2">
          <button *ngFor="let lang of availableLanguages"
            (click)="setCurrentLanguage(lang.code)"
            [class]="currentLocale === lang.code ? 
              'bg-indigo-600 text-white' : 
              'bg-gray-700 text-gray-300 hover:bg-gray-600'"
            class="px-3 py-1.5 rounded-md text-sm font-medium transition-colors duration-200">
            {{ lang.code.toUpperCase() }}
          </button>
        </div>
      </div>
    </div>

    <!-- Website Selector -->
    <div class="bg-gray-800 shadow-lg rounded-lg border border-gray-700 mb-8">
      <div class="px-4 py-5 sm:p-6">
        <app-website-selector></app-website-selector>
      </div>
    </div>
  </div>

  <app-notification></app-notification>
</div>
